import Api from "../services/AxiosService";
import { unwrap } from "./envelope";

export type TessellationMode = "bbox_ratio" | "absolute";

/** Response of GET /v1/cad/settings (svc-09-image-3d). */
export type Cad3dSettings = {
  tessellationMode: TessellationMode;
  bboxRatio: number | null;
  linearDeflectionMm: number | null;
  angularDeflection: number | null;
  matchThreshold: number;
  bboxDiagGateRatio: number;
  maxFileBytes: number;
  signatureVersion: string;
  updatedAt: string | null;
};

/**
 * PUT result — the settings plus whether the change altered the signature
 * (tessellation/signature params) and therefore warrants a library re-analysis.
 * Threshold/gate/cap changes apply instantly (signatureChanged=false).
 */
export type Cad3dSettingsUpdateResult = Cad3dSettings & {
  signatureChanged: boolean;
  reanalyzeRecommended: boolean;
};

export type UpdateCad3dSettingsBody = Partial<{
  tessellationMode: TessellationMode;
  bboxRatio: number;
  linearDeflectionMm: number;
  angularDeflection: number;
  matchThreshold: number;
  bboxDiagGateRatio: number;
  maxFileBytes: number;
}>;

export async function getCad3dSettings(): Promise<Cad3dSettings> {
  const res = await Api.get("/v1/cad/settings");
  return unwrap<Cad3dSettings>(res.data);
}

export async function updateCad3dSettings(
  body: UpdateCad3dSettingsBody,
): Promise<Cad3dSettingsUpdateResult> {
  const res = await Api.put("/v1/cad/settings", body);
  return unwrap<Cad3dSettingsUpdateResult>(res.data);
}

/** DELETE /v1/cad/uploads/:applicationId — removes the current STEP file + its
 *  GLB preview from S3 and the cad3d library rows (svc-09). */
export async function deleteCad3dUpload(applicationId: string): Promise<void> {
  await Api.delete(`/v1/cad/uploads/${encodeURIComponent(applicationId)}`);
}
